module.exports = __webpack_public_path__ + "img/andry--default.90e6b5ce.svg";